import React, { useEffect, useState } from "react";
import styles from "../../admin_styles/StatsOverview.module.css";

const formatNumber = (n) =>
  n?.toLocaleString("ru-RU") ?? "—";

const Card = ({ title, value }) => (
  <div className={styles.card}>
    <div className={styles.cardTitle}>{title}</div>
    <div className={styles.cardValue}>{value}</div>
  </div>
);

export default function StatsOverview() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;

    const fetchStats = async () => {
      try {
        const r = await fetch("/api/admin/get_count_projects_users");
        if (!r.ok) throw new Error("Ошибка сети: " + r.status);
        const data = await r.json();
        if (!ignore) {
          setStats(data);
          setLoading(false);
        }
      } catch (err) {
        console.error(err);
        if (!ignore) setLoading(false);
      }
    };

    fetchStats();
    return () => {
      ignore = true;
    };
  }, []);

  if (loading) return null;
  if (!stats) return null;

  const primaryColumn = [
    { title: "Пользователей", value: stats.users_total },
    { title: "Vip", value: stats.users_with_tariff },
    { title: "Trial", value: stats.users_trial },
    { title: "Проектов", value: stats.projects_total },
    { title: "Vip проектов", value: stats.projects_tariff },
  ];

  const secondaryColumn = [
    { title: "Bonus баланс", value: stats.bonus_balance_total },
    { title: "Real баланс", value: stats.real_balance_total },
    { title: "Avance баланс", value: stats.avance_balance_total },
    { title: "Всего объявлений", value: stats.total_ads_total },
    { title: "Vip объявлений", value: stats.total_ads_tariff },
    { title: "LTV", value: stats.ltv_total },
  ];

  return (
    <div className={styles.columns}>
      <div className={styles.grid}>
        {primaryColumn.map((item) => (
          <Card key={item.title} title={item.title} value={formatNumber(item.value)} />
        ))}
      </div>
      <div className={styles.grid}>
        {secondaryColumn.map((item) => (
          <Card key={item.title} title={item.title} value={formatNumber(item.value)} />
        ))}
      </div>
    </div>
  );
}
